import { render } from "./FormularioCupoLimitado.vue?vue&type=template&id=b6a82d6c&scoped=true&ts=true"
import script from "./FormularioCupoLimitado.vue?vue&type=script&lang=ts"
export * from "./FormularioCupoLimitado.vue?vue&type=script&lang=ts"

import "./FormularioCupoLimitado.vue?vue&type=style&index=0&id=b6a82d6c&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6a82d6c"]])

export default __exports__